export const LOAD_OH_CASE_COUNT_SUCCESS = "LOAD_OH_CASE_COUNT_SUCCESS";

export const LOAD_WORK_ADJUSTMENT_COUNT_SUCCESS = "LOAD_WORK_ADJUSTMENT_COUNT_SUCCESS";

export const LOAD_OH_CASE_COUNT = "LOAD_OH_CASE_COUNT";
export const LOAD_WORK_ADJUSTMENT_COUNT = "LOAD_WORK_ADJUSTMENT_COUNT";
